<template>
  <div>
    <v-dialog v-model="dialog" persistent width="600">
      <v-card>
        <v-toolbar color="white" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-car</v-icon>
            {{ $i18n.t("Create Invoice") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="closeDialog(false)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-row style="padding: 10px 10px">
            <v-btn-toggle rounded style="float: left; background: transparent">
              <v-btn small :color="report.clientType == 'corporate' ? 'blue' : 'grey'" @click="
  report.clientType = 'corporate';
flushFields('corporate');
              ">
                <h3 style="padding-right: 20px">
                  <div style="width: 20px; height: 12px; float: left" v-if="report.clientType == 'corporate'"></div>
                  <v-icon v-if="report.clientType == 'corporate'" color="white">mdi-check</v-icon>
                  {{ $i18n.t("For Corporate Client") }}
                </h3>
              </v-btn>
              <v-btn small :color="report.clientType != 'corporate' ? 'blue' : 'grey'" @click="
  report.clientType = 'individual';
report.clientBillToEntity_id = null;
report.clientShipEntity_id = null;
flushFields('individual');
              ">
                <h3 style="padding-right: 20px">
                  <div style="width: 20px; height: 12px; float: left" v-if="report.clientType != 'corporate'"></div>
                  <v-icon v-if="report.clientType != 'corporate'" color="white">mdi-check</v-icon>
                  {{ $i18n.t("For Individual Customer") }}
                </h3>
              </v-btn>
            </v-btn-toggle>
            <v-col v-if="report.invoiceKind == 1">
              <v-checkbox v-model="report.doNotSort"></v-checkbox>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" md="6" sm="12">
              <z-entity-select class="purple-input" :corp="filters.vendor_id" v-model="report.vendorEntity_id"
                :label="$i18n.t('Vendor Entity')"></z-entity-select>
            </v-col>
            <v-col cols="6" md="6" sm="12">
              <v-select :items="kinds" :label="$i18n.t('Invoice Kind')" v-model="report.invoiceKind" item-text="name"
                item-value="value"></v-select>
            </v-col>
            <v-col cols="6" md="6" sm="12" v-show="report.clientType != 'individual'">
              <z-entity-select class="purple-input" :corp="filters.client_id" v-model="report.clientBillToEntity_id"
                :label="$i18n.t('Billing Entity')"></z-entity-select>
            </v-col>
            <v-col cols="6" md="6" sm="12" v-show="report.clientType != 'individual'">
              <z-entity-select class="purple-input" :corp="filters.client_id" v-model="report.clientShipEntity_id"
                :label="$i18n.t('Shipping Entity')"></z-entity-select>
            </v-col>
            <v-col cols="6" md="6" sm="12">
              <v-row>
                <v-col cols="9" md="9" sm="9">
                  <v-text-field v-model="report.invoiceNo" @blur="invoiceNoAvailable"
                    :label="$i18n.t('Invoice No')"></v-text-field>
                </v-col>
                <v-col cols="3" md="3" sm="3">
                  <v-btn @click="getInvoiceNo" fab small text>
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" md="6" sm="12">
              <z-date-picker :label="$i18n.t('Invoice Date')" class="purple-input" v-model="report.invoiceDate"
                :autoSelect="true" />
            </v-col>
            <v-col cols="12" md="12" sm="12" v-if="report.clientType === 'individual'">
              <table class="table table-striped">
                <tr>
                  <td></td>
                  <td>{{ $i18n.t("Name") }}</td>
                  <td>{{ $i18n.t("Phone") }}</td>
                  <td>{{ $i18n.t("Email") }}</td>
                </tr>
                <tr v-for="(person, p) in persons" :key="p + 'perosn'">
                  <td>
                    <v-checkbox @click="setIndividual(person, person.checked)" v-model="person.checked" />
                  </td>
                  <td>
                    <v-text-field v-model="person.name" />
                  </td>
                  <td>
                    <v-text-field type="number" v-model="person.phone" />
                  </td>
                  <td>
                    <v-text-field v-model="person.email" />
                  </td>
                </tr>
              </table>

              <table class="table table-striped">
                <tr>
                  <td>{{ $i18n.t("Email") }}</td>
                  <td>{{ $i18n.t("GSTIN") }}</td>
                  <td>{{ $i18n.t("Country") }}</td>
                  <td>{{ $i18n.t("State") }}</td>
                  <td>{{ $i18n.t("Address") }}</td>
                </tr>
                <tr>
                  <td>
                    <v-text-field v-model="individualPan" :placeholder="$i18n.t('PAN NO')" />
                  </td>
                  <td>
                    <v-text-field v-model="individualGstin" :placeholder="$i18n.t('GSTIN')" />
                  </td>
                  <td style="width: 125px">
                    <z-country-select v-model="individualAddress.country"></z-country-select>
                  </td>
                  <td style="width: 125px">
                    <z-state-select v-model="individualAddress.state"
                      :coutry="individualAddress.country"></z-state-select>
                  </td>
                  <td>
                    <v-text-field v-model="individualAddress.addressLine" :placeholder="$i18n.t('Address Line')" />
                  </td>
                </tr>
              </table>
            </v-col>
            <!-- <v-col cols="6" md="6" sm="12">
              <v-checkbox
                v-model="report.overideTax"
                :label="$i18n.t('Overide existing tax Slab')"
              ></v-checkbox>
              <v-checkbox
                v-if="selctedTrips != null && selctedTrips.length > 1"
                v-model="report.doNotSort"
                :label="$i18n.t('Do Not Sort')"
              ></v-checkbox>
            </v-col> -->
            <!-- <v-col cols="6" md="6" sm="12" v-show="report.vendorEntity_id">
              {{ $i18n.t("Invoice Tax Will be Applied ") }}
              <span class style="color: red">
                {{ appliedTaxSlab.name }}
                {{ appliedTaxSlab.desc ? "-" + appliedTaxSlab.desc : "" }}
              </span>
            </v-col> -->
            <!-- <v-col cols="6" md="6" sm="12" v-show="report.overideTax">
              <v-select
                :items="taxList"
                :label="$i18n.t('Invoice Tax')"
                v-model="report.tax_id"
                item-text="name"
                item-value="_id"
              ></v-select>
            </v-col> -->
          </v-row>
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <span v-if="filters.invoiceType == 1 || invoicesForFare.length > 0">
            {{ $i18n.t("Fare Before Tax") }}:
            <b>{{ invoicesForFare[0].fare.subTotal }}</b>
          </span>
          <v-spacer></v-spacer>
          <v-btn @click="fetcInvoiceReportFare" color="teal" :loading="loadingFTF">{{
            $i18n.t("Fetch Total Fare")
          }}</v-btn>
          <v-btn @click="createInvoiceReport" color="teal" :loading="loadingCreate">
            {{ $i18n.t("Create") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="invoicesForFare.length > 0">
        <v-card-text>
          <v-row>
            <v-col cols="6" md="6" sm="12" v-for="(invoice, i) in invoicesForFare" :key="i + 'fare'">
              <ul class="list-unstyled">
                <li>
                  <strong>{{ $i18n.t("Sub Total") }} :</strong>
                  {{ invoice.fare.subTotal }}
                </li>
                <li v-for="(item, k) in invoice.charges" :key="k + 'charge'">
                  <strong>{{ item.name }}:</strong>
                  {{ item.applied }}
                </li>
                <li>
                  <strong>{{ $i18n.t("Discount") }} :</strong>
                  {{ invoice.fare.totalDiscounts }}
                </li>
                <li v-show="invoice.fare.taxes" v-for="(tax, j) in invoice.fare.taxes" :key="j + 'tax'">
                  <span>{{ tax.name }}{{ " " + tax.desc }}</span>
                  {{ tax.amount }}
                </li>
                <li>
                  <strong>{{ $i18n.t("Total Tax") }} :</strong>
                  {{ invoice.fare.totalTaxes }}
                </li>
                <li>
                  <strong>
                    {{ $i18n.t("Total with Tax") }} ({{
                      invoice.fare.currency
                    }}):
                  </strong>
                  {{ invoice.fare.total }} {{ invoice.currency }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "InvoiceDownload",
  props: {
    filters: {
      default: {},
    },
    showDialog: {
      default: false,
    },
    createInvoiceType: {
      default: "all",
    },
    selctedTrips: {
      default: () => [],
    },
  },
})
export default class InvoiceDownload extends (Vue, Themeable) {
  url = "api/invoiceconfig/invoice/formats";
  on = null;
  dialog = false;
  loading = false;
  loadingFTF = null;
  loadingCreate = null;
  kinds = [
    {
      name: "Single Invoice for All Selected Items",
      value: "",
    },
    {
      name: "One Invoice per Trip",
      value: "1",
    },
    // {`
    //   name: "One Invoice per Passenger",
    //   value: "2",
    // },
    // {
    //   name: "One Invoice per Cost Centre",
    //   value: "3",
    // },
    // {
    //   name: "One Invoice per Department",
    //   value: "4",
    // },`
  ];
  individualAddress = {
    country: "",
    state: "",
    addressLine: "",
  };
  individualPan = "";
  individualGstin = "";
  person = { name: "", phone: null, email: "", checked: false };
  taxList = [];
  report = {
    clientType: "corporate",
    clientBillToEntity_id: null,
    vendorEntity_id: null,
    clientShipEntity_id: null,
    invoiceKind: "",
    invoiceNo: "",
  };
  invoiceFormatList = [];
  appliedTaxSlab = {};
  invoicesForFare = [];
  individual = {};
  persons = [];

  mounted() {
    this.loading = false;
  }

  populateOnPopUpOpens() {
    this.report.clientType = "corporate";
    this.report.clientBillToEntity_id = null;
    this.report.vendorEntity_id = null;
    this.report.clientShipEntity_id = null;
    this.report.invoiceKind = "";
    this.report.invoiceNo = "";
    this.report.trip_ids = [];
    let oneTrip = false;
    if (this.selctedTrips && this.selctedTrips.length > 0) {     
      this.report.vendorEntity_id = this.selctedTrips[0]['vendorEntity_id'];
      for (let i = 0; i < this.selctedTrips.length; i++) {
        this.report.trip_ids.push(this.selctedTrips[i]._id);
      }
      if (this.selctedTrips.length == 1) {
        oneTrip = true;
        this.report.vendorEntity_id = this.selctedTrips[0]['vendorEntity_id'];
        if (this.selctedTrips[0].clientCargos && this.selctedTrips[0].clientCargos.length > 0) {
          for (let i = 0; i < this.selctedTrips[0]['clientCargos'].length; i++) {
            if (this.selctedTrips[0]['clientCargos'][i]['client_id'] === this.filters['client_id']) {
              //perform with this trip
              if (this.selctedTrips[0]['clientCargos'][i]['clientEntity_id']) {
                this.report.clientBillToEntity_id = this.selctedTrips[0]['clientCargos'][i]['clientEntity_id'];
                this.report.clientShipEntity_id = this.selctedTrips[0]['clientCargos'][i]['clientEntity_id'];
              }
            }
          }
        }
      }
      if (this.selctedTrips[0].clientCargos && this.selctedTrips[0].clientCargos.length > 0) {
        for (let i = 0; i < this.selctedTrips[0].clientCargos.length; i++) {
          if (this.filters['client_id']) {
            if (this.selctedTrips[0]['clientCargos'][i]['client_id'] === this.filters['client_id']) {
              if (this.selctedTrips[0]['clientCargos'][i]['clientEntity_id']) {
                this.report.clientEntity = this.selctedTrips[0]['clientCargos'][i]['clientEntity_id'];
              }
            }
          } else {
            this.report.clientEntity = this.selctedTrips[0]['clientCargos'][0]['clientEntity_id'];
            break;
          }
        }
      }

    }

    // if ("all" == this.createInvoiceType) {
    //   this.calcTotalFareBeforeTaxByAPI();
    // } else {
    //   this.calcTotalFareBeforeTax(this.selctedTrips);
    // }
    // if (this.createInvoiceType == "all") {
    //   this.setEntitiesFromAll();
    // } else {
    //   this.setEntitiesFromSelected();
    // }

    if (!oneTrip) {
      if(!this.report.clientEntity){
        this.report.clientEntity = this.filters.clientEntity_id;
      }  

      if (this.report.clientEntity) {
        this.report.clientBillToEntity_id = this.report.clientEntity;
        this.report.clientShipEntity_id = this.report.clientEntity;
      } else {
        this.report.clientBillToEntity_id = null;
        this.report.clientShipEntity_id = null;
      }
      this.report.vendorEntity = this.filters.vendorEntity_id;


      if (this.report.vendorEntity) {
        this.report.vendorEntity_id = this.report.vendorEntity;
      } 
    }
    // this.fetchTaxList();
    this.getInvoiceNo();
    // this.fetchAppliedTaxSlab();
  }

  setEntitiesFromAll() {
    // this.report.clientEntityConflict = false;
    // this.report.vendorEntityConflict = false;
    // if (this.selctedTrips && this.selctedTrips.length > 0) {
    //   for (let i = 0; i < this.selctedTrips.length; i++) {
    //     if (!this.report.clientEntityConflict) {
    //       if (!this.report.clientEntity) {
    //         this.report.clientEntity = this.selctedTrips[i].clientEntity_id;
    //       } else {
    //         if (
    //           this.report.clientEntity != this.selctedTrips[i].clientEntity_id
    //         ) {
    //           this.report.clientEntity = "";
    //           this.report.clientEntityConflict = true;
    //         }
    //       }
    //     }
    //     if (!this.report.vendorEntityConflict) {
    //       if (!this.report.vendorEntity) {
    //         this.report.vendorEntity = this.selctedTrips[i].vendorEntity_id;
    //       } else {
    //         if (
    //           this.report.vendorEntity != this.selctedTrips[i].vendorEntity_id
    //         ) {
    //           this.report.vendorEntity = "";
    //           this.report.vendorEntityConflict = true;
    //         }
    //       }
    //     }
    //     if (
    //       this.report.clientEntityConflict &&
    //       this.report.vendorEntityConflict
    //     ) {
    //       return;
    //     }
    //   }
    //   if (
    //     this.report.clientEntityConflict ||
    //     this.report.vendorEntityConflict
    //   ) {
    //     return;
    //   }
    // }
  }

  setEntitiesFromSelected() {
    // this.report.clientEntityConflict = false;
    // this.report.vendorEntityConflict = false;
    // if (this.selctedTrips && this.selctedTrips.length > 0) {
    //   for (let i = 0; i < this.selctedTrips.length; i++) {
    //     if (!this.report.clientEntityConflict) {
    //       if (!this.report.clientEntity) {
    //         this.report.clientEntity = this.selctedTrips[i].clientEntity_id;
    //       } else {
    //         if (
    //           this.report.clientEntity != this.selctedTrips[i].clientEntity_id
    //         ) {
    //           this.report.clientEntity = "";
    //           this.report.clientEntityConflict = true;
    //           // return;
    //         }
    //       }
    //     }
    //     if (!this.report.vendorEntityConflict) {
    //       if (!this.report.vendorEntity) {
    //         this.report.vendorEntity = this.selctedTrips[i].vendorEntity_id;
    //       } else {
    //         if (
    //           this.report.vendorEntity != this.selctedTrips[i].vendorEntity_id
    //         ) {
    //           this.report.vendorEntity = "";
    //           this.report.vendorEntityConflict = true;
    //           // return;
    //         }
    //       }
    //     }
    //     if (
    //       this.report.clientEntityConflict &&
    //       this.report.vendorEntityConflict
    //     ) {
    //       return;
    //     }
    //   }
    //   if (
    //     this.report.clientEntityConflict ||
    //     this.report.vendorEntityConflict
    //   ) {
    //     return;
    //   }
    // }
  }

  // calcTotalFareBeforeTax(trips) {
  //   let totalAmount = 0;
  //   for (let i = 0; i < trips.length; i++) {
  //     if (trips[i].fare != null && trips[i].fare.subTotal != null) {
  //       totalAmount =
  //         parseFloat(totalAmount) + parseFloat(trips[i].fare.subTotal);
  //     }
  //   }
  //   this.totalFareBeforeTax = totalAmount;
  // }

  // async calcTotalFareBeforeTaxByAPI() {
  //   this.totalFareBeforeTax = null;
  //   this.totalFareBeforeTax = await doPost(
  //     this.filterTripParam(
  //       "/api/invoice/create/invoice/get/subtotal?",
  //       this.filters
  //     ),
  //     this.report
  //   );
  // }

  appendParam(url, param, val) {
    if (val) {
      url = url + "&" + param + "=" + val;
    }
    return url;
  }

  setIndividual(person, checked) {
    for (let i = 0; i < this.persons.length; i++) {
      this.persons[i].checked = false;
    }
    if (!checked) this.individual = person;
  }

  filterTripParam(url, finalFilters) {
    url = this.appendParam(url, "client_id", finalFilters.client_id);
    url = this.appendParam(url, "vendor_id", finalFilters.vendor_id);
    let status = "";
    if (finalFilters.completedID) {
      status = finalFilters.completedID;
    }
    if (finalFilters.ranOfflineID) {
      status = status + "," + finalFilters.ranOfflineID;
    }
    if (finalFilters.cancelledID) {
      status = status + "," + finalFilters.cancelledID;
    }
    if (finalFilters.verified) {
      url = this.appendParam(url, "verified", true);
    }
    if (finalFilters.includeTaxFree) {
      url = this.appendParam(url, "includeTaxFree", true);
    }
    if (finalFilters.excludePayByCash) {
      url = this.appendParam(url, "excludePayByCash", true);
    }
    if (finalFilters.holdInvoicing) {
      url = this.appendParam(url, "holdInvoicing", true);
    }
    if (finalFilters.ignoreCancelled) {
      url = this.appendParam(url, "ignoreCancelled", true);
    }
    if (finalFilters.proforma) {
      url = this.appendParam(url, "proforma", finalFilters.proforma);
    }

    url = this.appendParam(url, "fromDate", finalFilters.bookingFromDate);
    url = this.appendParam(url, "toDate", finalFilters.bookingToDate);
    url = this.appendParam(url, "invoiceType", finalFilters.invoiceType);
    url = this.appendParam(url, "employeeName", finalFilters.employeeName);
    url = this.appendParam(url, "costCenter", finalFilters.costCenter);
    url = this.appendParam(url, "bookingNo", finalFilters.bookingNo);
    url = this.appendParam(url, "showInvoiced", finalFilters.showInvoiced);
    url = this.appendParam(url, "dutySlipNo", finalFilters.dutySlipNo);
    url = this.appendParam(url, "vehRegNo", finalFilters.vehRegNo);
    url = this.appendParam(url, "paymentMode", finalFilters.paymentMode);
    if (status) {
      url = this.appendParam(url, "status", status);
    }

    url = this.appendParam(url, "vendorEntity", finalFilters.vendorEntity_id);
    // url = this.appendParam(url, 'clientSA', finalFilters.clientSA);
    url = this.appendParam(url, "clientEntity", finalFilters.clientEntity_id);

    return url;
  }

  validateReport() {
    if (!this.filters.client_id) {
      common.setError("Please select client");
      return false;
    }
    if (!this.filters.vendor_id) {
      common.setError("Please select vendor");
      return false;
    }

    if (!this.filters.invoiceType) {
      common.setError("Please Select invoice type.");
      return false;
    }
    return true;
  }

  async createReport() {
    if (!this.validateReport()) {
      return;
    }
    this.report.trip_ids = [];
    if (this.selctedTrips && this.selctedTrips.length > 0) {
      for (let i = 0; i < this.selctedTrips.length; i++) {
        this.report.trip_ids.push(this.selctedTrips[i]._id);
      }
    }
    if (this.report.clientType && this.report.clientType === "individual") {
      if (!this.individual || !this.individual.name) {
        common.setError("Individual name and email is mandatory.");
        return;
      }
      this.report.passenger = {};
      this.report.passenger.name = this.individual.name;
      this.report.passenger.phone = this.individual.phone;
      this.report.passenger.email = this.individual.email;
      this.report.passenger.gstin = this.individualGstin;
      this.report.passenger.panNumber = this.individualPan;
      this.report.passenger.address = this.individualAddress;
      this.report.forIndividual = true;
    } else {
      this.report.forIndividual = false;
    }
    try {
      common.setLoading(true);
      this.loadingCreate = true;
      const response = await doPost(
        this.filterTripParam(
          "/api/invoice/create/invoice?_search=true",
          this.filters
        ),
        this.report
      );
      this.loadingCreate = null;
      common.setLoading(false);
      common.showMessage("Invoice Created successfully");
      window.open("/sales/invoice/" + response[0]._id, "_blank");
      this.closeDialog(true);
    } catch (e) {
      this.loadingCreate = null;
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async createSelectedReport() {
    this.report.trip_ids = [];
    if (this.selctedTrips && this.selctedTrips.length > 0) {
      for (let i = 0; i < this.selctedTrips.length; i++) {
        this.report.trip_ids.push(this.selctedTrips[i]._id);
      }
    }
    if (this.report.clientType && this.report.clientType == "individual") {
      if (!this.individual || !this.individual.name) {
        alert("Individual name and email is mandatory.");
        return;
      }
      this.report.passenger = {};
      this.report.passenger.name = this.individual.name;
      this.report.passenger.phone = this.individual.phone;
      this.report.passenger.email = this.individual.email;
      this.report.passenger.gstin = this.individualGstin;
      this.report.passenger.panNumber = this.individualPan;
      this.report.passenger.address = this.individualAddress;
      this.report.forIndividual = true;
    } else {
      this.report.forIndividual = false;
    }
    try {
      common.setLoading(true);
      this.loadingCreate = true;
      const response = await doPost(
        this.filterTripParam(
          "/api/invoice/create/invoice?_search=true",
          this.filters
        ),
        this.report
      );
      this.loadingCreate = null;
      common.showMessage("Invoice Created successfully");
      common.setLoading(false);
      window.open("/sales/invoice/" + response[0]._id, "_blank");
      this.closeDialog(true);
    } catch (e) {
      this.loadingCreate = null;
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  validateInvoiceCreate() {
    if (!this.report.vendorEntity_id) {
      common.setError("Please select venodr Entity.");
      return false;
    }
    if (!this.report.invoiceDate) {
      common.setError("Please select invoice date.");
      return false;
    }
    if (
      this.report.clientType == "corporate" &&
      (!this.report.clientBillToEntity_id || !this.report.clientShipEntity_id)
    ) {
      common.setError("Please select required fields.");
      return false;
    }
    if (
      this.report.clientType != "corporate" &&
      (!this.individual || !this.individual.name)
    ) {
      common.setError("Please select an individual.");
      return false;
    }
    return true;
  }

  createInvoiceReport() {
    if (!this.validateInvoiceCreate()) return;
    if (this.createInvoiceType == "all") {
      this.createReport();
    } else {
      this.createSelectedReport();
    }
  }

  // async fetchTaxList() {
  //   this.taxList = [];
  //   this.taxList = await doGet("/api/taxslab/all");
  // }

  // async fetchAppliedTaxSlab() {
  //   if (this.report.clientType && this.report.clientType === "individual") {
  //     this.report.forIndividual = true;
  //   } else {
  //     this.report.forIndividual = false;
  //   }
  //   let url = "/api/invoice/create/get/tax/slab?";
  //   if (
  //     this.report.vendorEntity_id &&
  //     (this.report.clientShipEntity_id || this.report.forIndividual)
  //   ) {
  //     url =
  //       url +
  //       "&vendor_id=" +
  //       this.filters.vendor_id +
  //       "&clientEntity_id=" +
  //       this.report.clientShipEntity_id +
  //       "&vendorEntity_id=" +
  //       this.report.vendorEntity_id +
  //       "&client_id=" +
  //       this.filters.client_id +
  //       "&forIndividual=" +
  //       this.report.forIndividual +
  //       "&amount=" +
  //       this.totalFareBeforeTax;
  //     this.appliedTaxSlab = await doGet(url);
  //   }
  // }

  async fetchReportFare() {
    if (!this.validateReport()) {
      return;
    }
    this.report.trip_ids = [];
    if (this.selctedTrips && this.selctedTrips.length > 0) {
      for (let i = 0; i < this.selctedTrips.length; i++) {
        this.report.trip_ids.push(this.selctedTrips[i]._id);
      }
    }
    if (this.report.clientType && this.report.clientType === "individual") {
      if (!this.individual || !this.individual.name) {
        common.setError("Individual name and email is mandatory.");
        return;
      }
      this.report.passenger = {};
      this.report.passenger.name = this.individual.name;
      this.report.passenger.phone = this.individual.phone;
      this.report.passenger.email = this.individual.email;
      this.report.passenger.gstin = this.individualGstin;
      this.report.passenger.panNumber = this.individualPan;
      this.report.passenger.address = this.individualAddress;
      this.report.forIndividual = true;
    } else {
      this.report.forIndividual = false;
    }
    try {
      this.loadingFTF = true;
      this.invoicesForFare = await doPost(
        this.filterTripParam(
          "/api/invoice/create/invoice/get/fare?_search=true&forInvoice=true",
          this.filters
        ),
        this.report
      );
      this.loadingFTF = null;
    } catch (e) {
      this.loadingFTF = null;
      this.invoicesForFare = [];
    }
  }

  async fetchSelectedReportFare() {
    this.report.trip_ids = [];
    if (this.selctedTrips && this.selctedTrips.length > 0) {
      for (let i = 0; i < this.selctedTrips.length; i++) {
        this.report.trip_ids.push(this.selctedTrips[i]._id);
      }
    }
    if (this.report.clientType && this.report.clientType == "individual") {
      if (!this.individual || !this.individual.name) {
        common.setError("Individual name and email is mandatory.");
        return;
      }
      this.report.passenger = {};
      this.report.passenger.name = this.individual.name;
      this.report.passenger.phone = this.individual.phone;
      this.report.passenger.email = this.individual.email;
      this.report.passenger.gstin = this.individualGstin;
      this.report.passenger.panNumber = this.individualPan;
      this.report.passenger.address = this.individualAddress;
      this.report.forIndividual = true;
    } else {
      this.report.forIndividual = false;
    }
    try {
      this.loadingFTF = true;
      this.invoicesForFare = await doPost(
        this.filterTripParam(
          "/api/invoice/create/invoice/get/fare?_search=true&forInvoice=true",
          this.filters
        ),
        this.report
      );
      this.loadingFTF = null;
    } catch (e) {
      this.loadingFTF = null;
      this.invoicesForFare = [];
      common.setError(e);
    }
  }

  fetcInvoiceReportFare() {
    this.invoicesForFare = [];
    if (!this.validateInvoiceCreate()) return;
    if (this.createInvoiceType == "all") {
      this.fetchReportFare();
    } else {
      this.fetchSelectedReportFare();
    }
  }

  flushFields(type) {
    if (type === "individual") {
      this.report.clientBillToEntity_id = null;
      this.report.clientShipEntity_id = null;
      this.report.invoiceNo = null;
    }
    if (type === "corporate") {
      this.report.invoiceNo = null;
    }
    this.getInvoiceNo();
    // this.fetchAppliedTaxSlab();
  }

  async getInvoiceNo() {
    this.availableInvoiceNo = null;
    this.report.invoiceNo = null;
    if (this.report.clientType && this.report.clientType === "individual") {
      this.report.forIndividual = true;
    } else {
      this.report.forIndividual = false;
    }
    let url = "/api/invoice/create/get/invoice/sequence?";
    console.log("clientShipEntity_id", this.report.clientShipEntity_id);
    if (
      this.report.vendorEntity_id &&
      (this.report.clientType === "individual" ||
        this.report.clientShipEntity_id)
    ) {
      url =
        url +
        "&vendor_id=" +
        this.filters.vendor_id +
        "&clientEntity_id=" +
        this.report.clientShipEntity_id +
        "&vendorEntity_id=" +
        this.report.vendorEntity_id +
        "&client_id=" +
        this.filters.client_id +
        "&date=" +
        this.report.invoiceDate +
        "&forIndividual=" +
        this.report.forIndividual;
      const response = await doGet(url);
      this.report.invoiceNo = response;
      this.availableInvoiceNo = response;
      this.error_invoice_no_not_available = false;
    }
  }

  async invoiceNoAvailable() {
    let url = "/api/invoice/create/get/invoice/sequence/available?";
    this.error_invoice_no_not_available = false;
    if (
      this.report.vendorEntity_id &&
      ((this.report.clientType && this.report.clientType == "individual") ||
        this.report.clientShipEntity_id) &&
      this.report.invoiceNo
    ) {
      url =
        url +
        "&vendor_id=" +
        this.filters.vendor_id +
        "&clientEntity_id=" +
        this.report.clientShipEntity_id +
        "&vendorEntity_id=" +
        this.report.vendorEntity_id +
        "&client_id=" +
        this.filters.client_id +
        "&invoiceNo=" +
        this.report.invoiceNo +
        "&date=" +
        this.report.invoiceDate +
        "&forIndividual=" +
        this.report.forIndividual;
      try {
        await doGet(url);
      } catch (e) {
        this.error_invoice_no_not_available = true;
      }
    }
  }

  closeDialog(reload) {
    this.dialog = false;
    this.$emit("closeDialog", reload);
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  tableHeight() {
    return window.innerHeight - 400 + "px";
  }

  @Watch("dialog")
  async onDialogChange(newVal) {
    if (newVal) {
      try {
        this.populateOnPopUpOpens();
      } catch (e) {
        common.setError(e.message);
      }
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}

.v-dialog>.v-card>.v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}

.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}

.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
